export default __webpack_public_path__ + "static/media/logo-lg.5de8727c.svg";